<pages-container
  [title]="'main.competencies'"
  [icon]="'psychology'">
  <div main-content>
    <div class="org-competency-page">
      @for (competency of competencies(); track competency.id) {
        <div class="competency" [class.disabled]="!competency.enabled">
          <div class="competency-title">
            <mat-checkbox [checked]="competency.enabled" (change)="toggleCompetency(competency)"></mat-checkbox>
            <div class="color" [style.background-color]="!!competency.enabled ?
            competency.competency.color : 'rgba(0, 0, 0, 0.4)'"></div>
            {{competency.competency.title}}
          </div>
          @for (skill of competency.competency.skills; track skill.id) {
            <div class="skill">- {{skill.title}}</div>
          }
        </div>
      }
    </div>
  </div>
</pages-container>
